import { API_HOST } from '@/utils/constants/api';

/**
 * Function that transforms relative URL (images/avatar.jpg)
 * to https://example.com/files/images/avatar.jpg where example.com
 * depends on production or staging environment
 *
 * @param url {string} - URL relative to API HOST endpoint
 * @returns {string}
 */

const getStaticApiUrl = (url) => {
  return API_HOST + '/files/' + url;
};
export default getStaticApiUrl;
